import { DialogComponent } from '@theme/dialog';

/** Switch between the collection filter and sort views of the same native facets form. */
class HenryCollectionFilters extends DialogComponent {
  openFilters() {
    this.dataset.panel = 'filters';
    this.showDialog();
  }

  openSort() {
    this.dataset.panel = 'sort';
    this.showDialog();
  }
}

if (!customElements.get('henry-collection-filters')) {
  customElements.define('henry-collection-filters', HenryCollectionFilters);
}
